import * as React from "react"

const DeleteIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.512 2.061a.474.474 0 0 1-.473.473H.942a.473.473 0 0 1 0-.946h2.66c.06-.126.11-.257.152-.39L3.88.815a.947.947 0 0 1 .9-.647h2.422a.947.947 0 0 1 .897.647l.127.383c.041.133.092.264.152.39h2.661a.473.473 0 0 1 .473.473ZM10.32 3.367 9.897 9.76a1.716 1.716 0 0 1-1.893 1.767H3.977A1.713 1.713 0 0 1 2.084 9.76l-.422-6.393a.19.19 0 0 1 .19-.201h8.278a.19.19 0 0 1 .189.201ZM6.66 7.11l.927-.928a.473.473 0 0 0-.669-.669l-.927.927-.928-.927a.473.473 0 0 0-.67.669l.928.928-.927.927a.474.474 0 1 0 .669.67l.928-.928.927.927a.473.473 0 0 0 .67-.669L6.66 7.11Z"
    />
  </svg>
)

export default DeleteIcon